// extracted by mini-css-extract-plugin
export var active = "_kp-2";
export var recordingDot = "_kp-1";
export var recordingIndicator = "_kp-0";